var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNullpointerLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45.73mm",
    height: "9.7079mm",
    viewBox: "0 0 45.73 9.7079",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "marker3936",
    overflow: "visible",
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.3 0 0 -.3 .69 0)",
    d: "m8.7186 4.0337-10.926-4.0177 10.926-4.0177c-1.7455 2.3721-1.7354 5.6175-6e-7 8.0354z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.625
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m0.48241 4.9689 0.65405-1.0223-1.0033-0.43815 0.12065-0.37465 1.0478 0.31115 0.0635-1.162h0.4064l0.0635 1.162 1.0478-0.31115 0.12065 0.37465-1.0033 0.43815 0.65405 1.0223-0.33655 0.23495-0.7493-0.9525-0.7493 0.9525z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.26458,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.8308 0.001999h13.771c0.63311 0 1.1428 0.50969 1.1428 1.1428v5.1977c0 0.63311-0.50969 1.1428-1.1428 1.1428h-13.771c-0.63311 0-1.1428-0.50969-1.1428-1.1428v-5.1977c0-0.63311 0.50969-1.1428 1.1428-1.1428z",
    fill: "#fff",
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#001529",
    stroke: "#001529",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.6718 2.8285h0.60325l0.05715 0.4699h0.0254q0.22225-0.22225 0.48895-0.381 0.27305-0.1651 0.635-0.1651 0.53975 0 0.79375 0.3302 0.254 0.32385 0.254 0.93345v1.9304h-0.7366v-1.8352q0-0.381-0.13335-0.55245-0.127-0.1778-0.45085-0.1778-0.2286 0-0.4064 0.10795t-0.3937 0.3302v2.1272h-0.7366z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.292 5.9463h-0.5969l-0.05715-0.4953h-0.0254q-0.22225 0.26035-0.48895 0.4191-0.2667 0.1524-0.61595 0.1524-0.5461 0-0.79375-0.32385-0.24765-0.3302-0.24765-0.9398v-1.9304h0.73025v1.8352q0 0.381 0.127 0.5588 0.13335 0.17145 0.4572 0.17145 0.22225 0 0.3937-0.1016 0.1778-0.1016 0.38735-0.36195v-2.1019h0.73025z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.169 1.4632h1.7145v3.3846q0 0.3175 0.15875 0.45085 0.15875 0.127 0.40005 0.127 0.2286 0 0.5334-0.12065l0.17145 0.53975q-0.22225 0.0762-0.4191 0.127-0.1905 0.0508-0.46355 0.0508-0.55245 0-0.83185-0.3175t-0.2794-0.89535v-2.7686h-0.98425z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.947 1.4632h1.7145v3.3846q0 0.3175 0.15875 0.45085 0.15875 0.127 0.40005 0.127 0.2286 0 0.5334-0.12065l0.17145 0.53975q-0.22225 0.0762-0.4191 0.127-0.1905 0.0508-0.46355 0.0508-0.55245 0-0.83185-0.3175t-0.2794-0.89535v-2.7686h-0.98425z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.01 5.7053v0.9779h-0.7366v-4.3498h0.60325l0.05715 0.3556h0.01905q0.2032-0.18415 0.46355-0.3048 0.2667-0.127 0.5334-0.127 0.3048 0 0.53975 0.1143 0.2413 0.10795 0.40005 0.3175 0.1651 0.20955 0.24765 0.50165 0.0889 0.2921 0.0889 0.65405 0 0.40005-0.1143 0.71755-0.1143 0.31115-0.31115 0.52705-0.1905 0.20955-0.4445 0.32385-0.24765 0.1143-0.51435 0.1143-0.2159 0-0.4445-0.09525-0.22225-0.09525-0.41275-0.27305zm0-1.0668q0.17145 0.15875 0.34925 0.22225 0.18415 0.0635 0.3302 0.0635 0.33655 0 0.5588-0.2667 0.22225-0.27305 0.22225-0.80645 0-0.4699-0.17145-0.73025-0.17145-0.26035-0.55245-0.26035-0.1778 0-0.36195 0.0889t-0.37465 0.28575z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.027 4.7655q0.20955 0.1905 0.50165 0.1905 0.1905 0 0.33655-0.0762 0.1524-0.08255 0.254-0.22225 0.10795-0.1397 0.1651-0.3302 0.05715-0.19685 0.05715-0.4318 0-0.32385-0.1016-0.56515zm0.99695-1.7526q-0.09525-0.0889-0.22225-0.13335-0.127-0.0508-0.27305-0.0508-0.1905 0-0.3429 0.08255-0.1524 0.0762-0.26035 0.2159-0.1016 0.1397-0.15875 0.33655-0.0508 0.19685-0.0508 0.4318 0 0.3175 0.09525 0.55245zm0.6858-0.23495q0.1778 0.2032 0.2794 0.48895 0.10795 0.2794 0.10795 0.62865 0 0.38735-0.13335 0.69215-0.127 0.3048-0.3429 0.51435t-0.50165 0.3175-0.59055 0.10795q-0.24765 0-0.4826-0.06985-0.2286-0.06985-0.42545-0.20955l-0.29845 0.3556-0.2921-0.2286 0.3175-0.37465q-0.18415-0.2032-0.28575-0.4826t-0.1016-0.6223q0-0.38735 0.127-0.69215 0.13335-0.3048 0.34925-0.51435t0.50165-0.3175q0.28575-0.1143 0.59055-0.1143 0.50165 0 0.9017 0.27305l0.3048-0.3556 0.2921 0.2286z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.215 2.3335h2.0828v3.1179h-0.73025v-2.54h-1.3526zm1.6637-0.5461q-0.22225 0-0.37465-0.13335-0.14605-0.13335-0.14605-0.3556t0.14605-0.3556q0.1524-0.1397 0.37465-0.1397 0.2286 0 0.37465 0.1397 0.14605 0.13335 0.14605 0.3556t-0.14605 0.3556-0.37465 0.13335z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.657 2.3335h0.60325l0.05715 0.4699h0.0254q0.22225-0.22225 0.48895-0.381 0.27305-0.1651 0.635-0.1651 0.53975 0 0.79375 0.3302 0.254 0.32385 0.254 0.93345v1.9304h-0.7366v-1.8352q0-0.381-0.13335-0.55245-0.127-0.1778-0.45085-0.1778-0.2286 0-0.4064 0.10795t-0.3937 0.3302v2.1272h-0.7366z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.144 2.9113h-0.83185v-0.5461l0.8636-0.03175 0.09525-0.8509h0.60325v0.8509h1.4224v0.57785h-1.4224v1.2827q0 0.38735 0.15875 0.5715 0.15875 0.1778 0.5588 0.1778 0.2032 0 0.3683-0.03175 0.1651-0.0381 0.3175-0.09525l0.1397 0.5334q-0.20955 0.06985-0.46355 0.12065-0.254 0.05715-0.53975 0.05715-0.3556 0-0.5969-0.09525t-0.3937-0.2667q-0.14605-0.1778-0.2159-0.42545-0.0635-0.24765-0.0635-0.5461z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.119 3.8956q0-0.381 0.13335-0.6858 0.1397-0.3048 0.36195-0.51435 0.22225-0.2159 0.508-0.32385 0.2921-0.1143 0.5969-0.1143 0.34925 0 0.61595 0.1143 0.27305 0.10795 0.4572 0.3048 0.18415 0.1905 0.2794 0.46355 0.09525 0.27305 0.09525 0.5969 0 0.10795-0.0127 0.2032-0.0063 0.09525-0.01905 0.1524h-2.267q0.0381 0.4191 0.3302 0.6477 0.2921 0.22225 0.71755 0.22225 0.2413 0 0.45085-0.0635 0.20955-0.06985 0.42545-0.1905l0.24765 0.4572q-0.254 0.15875-0.56515 0.26035t-0.65405 0.1016q-0.3556 0-0.66675-0.10795-0.31115-0.1143-0.53975-0.32385t-0.36195-0.508q-0.13335-0.3048-0.13335-0.69215zm2.3749-0.29845q0-0.36195-0.1905-0.56515-0.1905-0.20955-0.56515-0.20955-0.3175 0-0.56515 0.19685-0.24765 0.19685-0.31115 0.57785z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.114 2.3335h0.60325l0.0635 0.70485h0.01905q0.2413-0.381 0.57785-0.57785 0.3429-0.2032 0.7493-0.2032 0.1905 0 0.32385 0.03175 0.1397 0.0254 0.2794 0.09525l-0.1524 0.61595q-0.1524-0.0508-0.27305-0.06985-0.1143-0.0254-0.2921-0.0254-0.32385 0-0.6223 0.18415-0.29845 0.18415-0.53975 0.64135v1.7208h-0.7366z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m43.487 5.252v2.6746c0 0.68171 0 1.0488-0.1453 1.2322s-0.43616 0.1834-3.312 0.1834h-11.185c-2.8484 0-3.0845 0-3.2027-0.20568s-0.1182-0.61729-0.1182-1.0799v-1.4899",
    fill: "none",
    markerEnd: "url(#marker3936)",
    stroke: "#fff",
    strokeWidth: 0.73554
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNullpointerLogo);
export default __webpack_public_path__ + "static/media/nullpointer_logo.f37f8e6c.svg";
export { ForwardRef as ReactComponent };